import {
  FETCH_CONFIGURATIONS_REQUEST,
  FETCH_CONFIGURATIONS_SUCCESS,
  FETCH_CONFIGURATIONS_FAILURE,
  FETCH_CONFIGURATION_REQUEST,
  FETCH_CONFIGURATION_SUCCESS,
  FETCH_CONFIGURATION_FAILURE,
  CREATE_CONFIGURATION_REQUEST,
  CREATE_CONFIGURATION_SUCCESS,
  CREATE_CONFIGURATION_FAILURE,
  UPDATE_CONFIGURATION_REQUEST,
  UPDATE_CONFIGURATION_SUCCESS,
  UPDATE_CONFIGURATION_FAILURE,
  DELETE_CONFIGURATION_REQUEST,
  DELETE_CONFIGURATION_SUCCESS,
  DELETE_CONFIGURATION_FAILURE,
  ACTIVE_CONFIGURATION_REQUEST,
  ACTIVE_CONFIGURATION_SUCCESS,
  ACTIVE_CONFIGURATION_FAILURE,
  DOWNLOAD_CONFIGURATION_REQUEST,
  DOWNLOAD_CONFIGURATION_SUCCESS,
  DOWNLOAD_CONFIGURATION_FAILURE,
  FETCH_MAX_EVENTID_REQUEST,
  FETCH_MAX_EVENTID_SUCCESS,
  FETCH_MAX_EVENTID_FAILURE,
  FETCH_ACTIVE_CONFIGURATION_ID_REQUEST,
  FETCH_ACTIVE_CONFIGURATION_ID_SUCCESS,
  FETCH_ACTIVE_CONFIGURATION_ID_FAILURE,
  FETCH_CONFIGURATIONS_BY_COMPANY_REQUEST,
  FETCH_CONFIGURATIONS_BY_COMPANY_SUCCESS,
  FETCH_CONFIGURATIONS_BY_COMPANY_FAILURE,
  FETCH_CONFIGURATIONS_BY_COUNTRY_REQUEST,
  FETCH_CONFIGURATIONS_BY_COUNTRY_SUCCESS,
  FETCH_CONFIGURATIONS_BY_COUNTRY_FAILURE,
  FETCH_CONFIGURATIONS_BY_USER_REQUEST,
  FETCH_CONFIGURATIONS_BY_USER_SUCCESS,
  FETCH_CONFIGURATIONS_BY_USER_FAILURE,
} from "./types";

const initialState = {
  configurations: [],
  configuration: null,
  loading: false,
  error: "",
  downloadedConfiguration: null,
  maxEventId: null,
  activeConfigId: null,
  uploadedImage: null, // New state to store uploaded image data
};

export function configurationReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_CONFIGURATIONS_REQUEST:
    case FETCH_CONFIGURATION_REQUEST:
    case CREATE_CONFIGURATION_REQUEST:
    case UPDATE_CONFIGURATION_REQUEST:
    case DELETE_CONFIGURATION_REQUEST:
    case ACTIVE_CONFIGURATION_REQUEST:
    case FETCH_MAX_EVENTID_REQUEST:
    case FETCH_ACTIVE_CONFIGURATION_ID_REQUEST:
    case FETCH_CONFIGURATIONS_BY_COMPANY_REQUEST:
    case FETCH_CONFIGURATIONS_BY_COUNTRY_REQUEST:
    case FETCH_CONFIGURATIONS_BY_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DOWNLOAD_CONFIGURATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case DOWNLOAD_CONFIGURATION_SUCCESS:
      return {
        ...state,
        downloadedConfiguration: action.payload,
        loading: false,
        error: "",
      };

    case DOWNLOAD_CONFIGURATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case FETCH_CONFIGURATIONS_SUCCESS:
      return {
        ...state,
        configurations: action.payload,
        loading: false,
        error: "",
      };

    case FETCH_CONFIGURATION_SUCCESS:
    case CREATE_CONFIGURATION_SUCCESS:
    case UPDATE_CONFIGURATION_SUCCESS:
      return {
        ...state,
        configuration: action.payload,
        loading: false,
        error: "",
      };

    case DELETE_CONFIGURATION_SUCCESS:
      return {
        ...state,
        configurations: state.configurations.filter(
          (config) => config._id !== action.payload
        ),
        loading: false,
        error: "",
      };

    case ACTIVE_CONFIGURATION_SUCCESS:
      return {
        ...state,
        activeConfigId: action.payload,
        loading: false,
        error: "",
      };

    case FETCH_MAX_EVENTID_SUCCESS:
      return {
        ...state,
        maxEventId: action.payload,
        loading: false,
        error: "",
      };

    case FETCH_ACTIVE_CONFIGURATION_ID_SUCCESS:
      return {
        ...state,
        activeConfigId: action.payload,
        loading: false,
        error: "",
      };

    case FETCH_CONFIGURATIONS_BY_COMPANY_SUCCESS:
      return {
        ...state,
        configurations: action.payload,
        loading: false,
        error: "",
      };

    case FETCH_CONFIGURATIONS_BY_COUNTRY_SUCCESS:
      return {
        ...state,
        configurations: action.payload,
        loading: false,
        error: "",
      };

    case FETCH_CONFIGURATIONS_BY_USER_SUCCESS:
      return {
        ...state,
        configurations: action.payload,
        loading: false,
        error: "",
      };

    case FETCH_CONFIGURATIONS_FAILURE:
    case FETCH_CONFIGURATION_FAILURE:
    case CREATE_CONFIGURATION_FAILURE:
    case UPDATE_CONFIGURATION_FAILURE:
    case DELETE_CONFIGURATION_FAILURE:
    case ACTIVE_CONFIGURATION_FAILURE:
    case FETCH_MAX_EVENTID_FAILURE:
    case FETCH_ACTIVE_CONFIGURATION_ID_FAILURE:
    case FETCH_CONFIGURATIONS_BY_COMPANY_FAILURE:
    case FETCH_CONFIGURATIONS_BY_COUNTRY_FAILURE:
    case FETCH_CONFIGURATIONS_BY_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
